import fetchDirectory from '../Services/fetchDirectory';
import fetchProject from '../Services/fetchProject';

export default () => async (dispatch) => {
  
  dispatch(fetchDirectory());
  dispatch(fetchProject());
    
}